import React from 'react'
import { withRouter } from 'react-router-dom'
import { AuthContext } from '../main/authProvider'
import {
    LineChart, Line,
    AreaChart, Area,
    PieChart, Pie, Cell,
    XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer,
} from 'recharts'
import './menuHome.css'
import DashboardService from '../app/service/dashboardService'
import HandleErrorService from '../app/service/handleErrorService'

// ═══════════════════════════════════════════════════════════════════════════════
// DADOS MOCKADOS — substitua cada constante pelo retorno da sua API REST
// ═══════════════════════════════════════════════════════════════════════════════

const INITIAL_KPIS = [
    {
        id: 'soma_faturamento_periodo',
        label: 'Faturamento (Notas Fiscais) \n Últimos 7 dias',
        valor: 0,
        icon: 'pi-money-bill',
        corIcone: '#10b981',
        fundoIcone: '#d1fae5',
    },
    {
        id: 'compras_mercarodia',
        label: 'Compras de mercadoria \n Últimos 7 dias',
        valor: 0,
        icon: 'pi-box',
        corIcone: '#ef4444',
        fundoIcone: '#fee2e2',
    },
    {
        id: 'contratacao_servicos',
        label: 'Contratação de serviços \n Últimos 7 dias',
        valor: 0,
        icon: 'pi-book',
        corIcone: '#ef4444',
        fundoIcone: '#fee2e2',
    },
    {
        id: 'contas_a_pagar_hoje',
        label: 'Contas a pagar \n Hoje',
        valor: 0,
        icon: 'pi-wallet',
        corIcone: '#ef4444',
        fundoIcone: '#fee2e2',
    },
]

// const MOCK_FATURAMENTO_7_DIAS = [
//     { dia: '03/05', valor: 9800 },
//     { dia: '04/05', valor: 11000 },
//     { dia: '05/05', valor: 9800 },
//     { dia: '06/05', valor: 6200 },
//     { dia: '07/05', valor: 4500 },
//     { dia: '08/05', valor: 13800 },
//     { dia: '09/05', valor: 12450 },
// ]

// const MOCK_CONTAS_CATEGORIA = [
//     { name: 'Fornecedores', value: 1800 },
//     { name: 'Impostos',     value: 750  },
//     { name: 'Salários',     value: 920  },
//     { name: 'Outros',       value: 350  },
// ]

// const MOCK_FLUXO_CAIXA = [
//     { dia: '01/05/2026', entradas: 12500, saidas: 7200 },
//     { dia: '02/05/2026', entradas: 8300,  saidas: 5100 },
//     { dia: '03/05/2026', entradas: 15200, saidas: 9800 },
//     { dia: '04/05/2026', entradas: 11000, saidas: 6300 },
//     { dia: '05/05/2026', entradas: 9800,  saidas: 8200 },
//     { dia: '06/05/2026', entradas: 6200,  saidas: 4100 },
//     { dia: '07/05/2026', entradas: 4500,  saidas: 2800 },
//     { dia: '08/05/2026', entradas: 13800, saidas: 7900 },
//     { dia: '09/05/2026', entradas: 16200, saidas: 10500 },
//     { dia: '10/05/2026', entradas: 11700, saidas: 8300 },
//     { dia: '11/05/2026', entradas: 14300, saidas: 9100 },
//     { dia: '12/05/2026', entradas: 10900, saidas: 7600 },
//     { dia: '13/05/2026', entradas: 7800,  saidas: 5200 },
//     { dia: '14/05/2026', entradas: 5100,  saidas: 3400 },
//     { dia: '15/05/2026', entradas: 18500, saidas: 12000 },
//     { dia: '16/05/2026', entradas: 13200, saidas: 8700 },
//     { dia: '17/05/2026', entradas: 11600, saidas: 7800 },
//     { dia: '18/05/2026', entradas: 15800, saidas: 10200 },
//     { dia: '19/05/2026', entradas: 12400, saidas: 8100 },
//     { dia: '20/05/2026', entradas: 9200,  saidas: 6300 },
//     { dia: '21/05/2026', entradas: 6700,  saidas: 4500 },
//     { dia: '22/05/2026', entradas: 14100, saidas: 9300 },
//     { dia: '23/05/2026', entradas: 17300, saidas: 11200 },
//     { dia: '24/05/2026', entradas: 13500, saidas: 8900 },
//     { dia: '25/05/2026', entradas: 12800, saidas: 8400 },
//     { dia: '26/05/2026', entradas: 15600, saidas: 10100 },
//     { dia: '27/05/2026', entradas: 8900,  saidas: 5800 },
//     { dia: '28/05/2026', entradas: 6100,  saidas: 4200 },
//     { dia: '29/05/2026', entradas: 14700, saidas: 9600 },
//     { dia: '30/05/2026', entradas: 12450, saidas: 8150 },
// ]

// ═══════════════════════════════════════════════════════════════════════════════

const PIE_COLORS = ['#2c4670', '#4a7ab5', '#7aa8d4', '#b0cce6']

const formatCurrency = (v) =>
    new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(v)

const formatDiaComSemana = (dia) => {
    if (!dia) return dia
    const [d, m, a] = dia.split('/')
    const date = new Date(a, m - 1, d)
    const semana = date.toLocaleDateString('pt-BR', { weekday: 'long' }).toLowerCase()
    return `${dia} (${semana})`
}

const formatCurrencyShort = (v) => {
    if (v >= 1000) return `R$ ${(v / 1000).toFixed(0)}k`
    return `R$ ${v}`
}

class MenuHome extends React.Component {

    constructor(){
        super()
        this.dashboardService = new DashboardService();

    }

    state = {
        dashboard: { kpiList: INITIAL_KPIS }
    }

    componentDidMount(){
        this.generateDashboard()
    }

    generateDashboard = () => {
        this.dashboardService.generateDashboard(30)
        .then(response => {
            // console.log(response.data)
            this.setState({dashboard: response.data})
        })
        .catch(error => {
            // HandleErrorService.handleError(error)
        })
    }


    render() {
        const dataHoje = new Date().toLocaleDateString('pt-BR', {
            weekday: 'long', year: 'numeric', month: 'long', day: 'numeric',
        })
        const dataFormatada = dataHoje.charAt(0).toUpperCase() + dataHoje.slice(1)

        const TooltipCurrency = ({ active, payload, label }) => {
            if (!active || !payload?.length) return null
            return (
                <div className="dash-tooltip">
                    <p className="dash-tooltip-label">{formatDiaComSemana(label)}</p>
                    {payload.map((entry, i) => (
                        <p key={i}>
                            {entry.name}: {formatCurrency(entry.value)}
                        </p>
                    ))}
                </div>
            )
        }

        const TooltipPie = ({ active, payload }) => {
            if (!active || !payload?.length) return null
            return (
                <div className="dash-tooltip">
                    <p style={{ margin: 0 }}>{payload[0].name}: {formatCurrency(payload[0].value)}</p>
                </div>
            )
        }

        const legendFormatter = (value, entry) => (
            <span style={{ fontSize: 12, color: '#374151' }}>{value}</span>
        )

        const renderKpiCards = () => {
            return(
                <div className="kpi-grid">
                    {/* {MOCK_KPIS.map(kpi => ( */}
                    {this.state.dashboard?.kpiList?.map(kpi => (
                        <div key={kpi.id} className="kpi-card">
                            <div>
                                <p className="kpi-label">{kpi.label}</p>
                                <p className="kpi-value">{formatCurrency(kpi.valor)}</p>
                                <p className={`kpi-info ${kpi.infoPositivo ? 'kpi-info-pos' : 'kpi-info-neg'}`}>
                                    {kpi.info}
                                </p>
                            </div>
                            <div className="kpi-icon-wrap" style={{ background: kpi.fundoIcone }}>
                                <i className={`pi ${kpi.icon}`} style={{ color: kpi.corIcone }} />
                            </div>
                        </div>
                    ))}
                </div>
            )
        }

        const renderFluxoCaixaRealizado = () => {
            return(
                <div className="chart-card">
                    <p className="chart-title">{this.state.dashboard?.fluxoCaixaRealizado?.titulo}</p>
                    <ResponsiveContainer width="100%" height={250}>
                        <AreaChart
                            // data={MOCK_FLUXO_CAIXA}
                            data={this.state.dashboard?.fluxoCaixaRealizado?.fluxoCaixaPorDiaList}
                            margin={{ top: 4, right: 16, left: 0, bottom: 0 }}
                        >
                            <defs>
                                <linearGradient id="gradEntradas" x1="0" y1="0" x2="0" y2="1">
                                    <stop offset="5%"  stopColor="#10b981" stopOpacity={0.25} />
                                    <stop offset="95%" stopColor="#10b981" stopOpacity={0}    />
                                </linearGradient>
                                <linearGradient id="gradSaidas" x1="0" y1="0" x2="0" y2="1">
                                    <stop offset="5%"  stopColor="#ef4444" stopOpacity={0.2} />
                                    <stop offset="95%" stopColor="#ef4444" stopOpacity={0}   />
                                </linearGradient>
                            </defs>
                            <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
                            <XAxis dataKey="dia" tick={{ fontSize: 11, fill: '#6b7280' }} interval={4} />
                            <YAxis tickFormatter={formatCurrencyShort} tick={{ fontSize: 11, fill: '#6b7280' }} width={70} />
                            <Tooltip content={<TooltipCurrency />} />
                            <Legend formatter={legendFormatter} iconSize={10} />
                            <Area
                                type="monotone"
                                dataKey="entradas"
                                name="Entradas"
                                stroke="#10b981"
                                strokeWidth={2}
                                fill="url(#gradEntradas)"
                            />
                            <Area
                                type="monotone"
                                dataKey="saidas"
                                name="Saídas"
                                stroke="#ef4444"
                                strokeWidth={2}
                                fill="url(#gradSaidas)"
                            />
                        </AreaChart>
                    </ResponsiveContainer>
                </div>
            )
        }

        return (
            <div className="dashboard-container">

                {/* ── Cabeçalho ── */}
                <div className="dashboard-header">
                    <p className="dashboard-greeting">Olá, seja bem-vindo!</p>
                    <p className="dashboard-date">{dataFormatada}</p>
                </div>

                {renderKpiCards()}

                {/* ── Faturamento 7 dias + Contas por categoria ── */}
                {/* <div className="charts-row-2col"> */}
                <div className="">

                    {/* <div className="chart-card">
                        <p className="chart-title">{this.state.dashboard.faturamento?.label}</p>
                        <ResponsiveContainer width="100%" height={230}>
                            <LineChart data={MOCK_FATURAMENTO_7_DIAS} margin={{ top: 4, right: 16, left: 0, bottom: 0 }}>
                            <LineChart data={this.state.dashboard.faturamento?.faturamentoList} margin={{ top: 4, right: 16, left: 0, bottom: 0 }}>
                                <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
                                <XAxis dataKey="dia" tick={{ fontSize: 12, fill: '#6b7280' }} />
                                <YAxis tickFormatter={formatCurrencyShort} tick={{ fontSize: 11, fill: '#806b6d' }} width={70} />
                                <Tooltip content={<TooltipCurrency />} />
                                <Line
                                    type="monotone"
                                    dataKey="valor"
                                    name="Faturamento"
                                    stroke="#2c4670"
                                    strokeWidth={2.5}
                                    dot={{ fill: '#2c4670', r: 4 }}
                                    activeDot={{ r: 6 }}
                                />
                            </LineChart>
                        </ResponsiveContainer>
                    </div> */}

                    {/* <div className="chart-card">
                        <p className="chart-title">Contas a Pagar Hoje — por Categoria</p>
                        <ResponsiveContainer width="100%" height={230}>
                            <PieChart>
                                <Pie
                                    data={MOCK_CONTAS_CATEGORIA}
                                    cx="50%"
                                    cy="45%"
                                    innerRadius={55}
                                    outerRadius={85}
                                    paddingAngle={3}
                                    dataKey="value"
                                >
                                    {MOCK_CONTAS_CATEGORIA.map((_, i) => (
                                        <Cell key={i} fill={PIE_COLORS[i % PIE_COLORS.length]} />
                                    ))}
                                </Pie>
                                <Tooltip content={<TooltipPie />} />
                                <Legend formatter={legendFormatter} iconSize={10} />
                            </PieChart>
                        </ResponsiveContainer>
                    </div> */}
                </div>

                {renderFluxoCaixaRealizado()}

            </div>
        )
    }
}

MenuHome.contextType = AuthContext

export default withRouter(MenuHome)
